import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareDotedBehindSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareDotedBehindSquare"><Path d="M8.5 7.5V8.5M8.5 5.5V2.5H11.5M18.5 2.5H21.5V5.5M13.5 2.5H16.5M21.5 7.5V10.5M21.5 12.5V15.5H18.5M16.5 15.5H15.5M15.5 8.5H2.5V21.5H15.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareDotedBehindSquare;
